import React from 'react'
import ScrollUpButton from 'react-scroll-up-button'

const OpenCampaignPage = () => (
  <div className='open-campaign'>
    <ul className="breadcrumb">
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <a href="/" itemProp="url">
          <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
        </a>
      </li>
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <span itemProp="title"> <i className="fas fa-caret-right"></i> 開業キャンペーン</span>
      </li>
    </ul>
    <div className='column'>
      <img src='images/campaign_image.png' alt='' width='100%' />
    </div>
    <div className='column'>
      <h3>【キャンペーン内容】</h3>
      2021/12/25のクリスマスの日に、駄菓子屋付きシェアハウスの営業を開始しました。<br />
      コロナ第5波の感染の状況を鑑み、1年半の延長期間を経て、開業する運びとなりました。<br />
      つきましては、<span class='textdecoration'>2022年3月末まで</span>の開業記念キャンペーンを開催致します。<br />
      <br />
      <div className='description'>
        キャンペーンの内容は以下の通りです。
        <ul>
          <li>1ヶ月のお家賃が無料</li>
          <li>入居者共有の電動自転車を設置</li>
          <li>希望者にパソコン教室を実施</li>
        </ul>
      </div>
    </div>
    <div className='column'>
      <h3>【申込み方法】</h3>
      <a href='/flow'>入居までの流れ</a>ページで全体の流れをご確認の上、<a href='/contact'>お問い合わせ</a> ページよりお問い合わせの内容、もしくは、内覧希望の旨をお伝え下さい。
      <span class='causion'>
      キャンペーン適用者は、2022年3月中のお申し込みが必須となりますのでご注意ください。<br />
      先着順となっておりますので、お早めのご応募をお願い致します。<br />
      </span>
      <br />
    </div>
    <div className='column'>
      <h3>【お願いごと】</h3>
      <div className='description'>
        当シェアハウスの以下のサービスにつきましては、入居者様のご要望を伺いながら、<br />
        特に下記につきまして、発展させていく予定です。
        <ul>
          <li>駄菓子屋の売り場スペース</li>
          <li>中庭のアンティーク空間の装飾品や家庭菜園</li>
          <li>屋上テラス</li>
          <li>リビングなどの共有スペース</li>
        </ul>
      </div>
      サービス向上、より良い入居生活の為に、改善致しますので、<br />
      入居者様からの忌憚ないご意見・ご要望を、日々お待ち申し上げます。
    </div>
    <ScrollUpButton style={{width: 30, height: 30}} />
  </div>
)

export default OpenCampaignPage


// WEBPACK FOOTER //
// ./src/OpenCampaignPage.js